<template>
  <div class="page">
    <nav-bar title="恭喜完成答题" :fixed="true" :placeholder="true" left-text="返回" left-arrow @click-left="onClickLeft"/>

    <div class="summer">
      <div class="content">
        <empty
            class="custom-image"
            image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
            description="感谢参与本次答题"
        />
      </div>

      <div class="tools">
        <div class="btn plan" @click="toAnalysis">查看报告</div>
      </div>
    </div>
  </div>
</template>
<script>
import {NavBar, Empty} from "vant";
import {getSchemeInfo, getProjectInfo} from "@api/eval";
import {mapGetters} from "vuex";

export default {
  components: {
    NavBar, Empty
  },
  computed: mapGetters(['userInfo']),
  data: function () {
    return {
      projectId: this.$route.params.projectId,
      projectInfo: {},
      schemeInfo: {},
    };
  },
  created() {
    this.init();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    toAnalysis() {
      if (this.projectInfo && this.schemeInfo) {
        if (this.schemeInfo.type === 'person') {
          window.location.href = `/api/wx/dispatch/person/${this.projectId}/${this.userInfo.id}`
        } else if (this.schemeInfo.flag == 'fenc-simple' || this.schemeInfo.flag == 'fenc-m') {
          window.location.href = `/api/standard/evaluate/fenc/result/simple/${this.userInfo.id}/${this.projectId}`;
        } else {
          window.location.href = `/api/evaluate/result/simple/${this.projectId}/${this.userInfo.id}/${this.schemeInfo.id}`
        }
      }
    },
    init() {
      getProjectInfo(this.projectId).then(res => {
        this.projectInfo = res.result || {}
      })
      getSchemeInfo(this.projectId).then(res => {
        console.info(res.result)
        this.schemeInfo = res.result || {}
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.page {
  background: url("~@images/practice_bg.png") 0 0 #1db0fc no-repeat;
  min-height: 100vh;

  .summer {
    width: 90%;
    margin: 20px auto;
    background-color: #fff;
    border-radius: 8px;
    position: relative;
    min-height: 360px;

    .content {
      position: relative;
      top: 40px;

      .name {
        font-size: 18px;
        color: #666;
        text-align: center;

      }

      .sale {
        margin-top: 38px;
        color: #fe5859;
        font-size: 46px;
        font-weight: 700;
        text-align: center;
        padding-left: 10px;

        .percent {
          font-size: 32px;
        }
      }

      .desc {
        color: #666;
        text-align: center;
        font-size: 18px;
        font-weight: 700;
        margin: 10px 0;
      }

    }

    .data {
      display: flex;
      padding: 20px 10px;
      justify-content: space-around;
      align-items: center;
      text-align: center;
      margin-top: 30px;

      .item {
        .num {
          font-size: 14px;
          font-weight: 400;
        }

        .title {
          font-size: 14px;
          color: #898989;
          margin: 10px 0;
        }
      }
    }

    .tools {
      margin-top: 35px;
      display: flex;

      .btn {
        margin: 10px auto;
        padding: 6px 20px;
        text-align: center;
        background-color: #00aaea;
        color: #fff;
        border-radius: 30px;
        font-size: 12px;

        &.info {
          background-color: #fff;
          color: #00aaea;
          border: 1px solid #00aaea;

        }

        &.error {
          color: #fff;
          border: 1px solid #fe5859;
          background-color: #fe5859;
        }
      }
    }

  }

}
</style>
